import React from 'react'
import { List, Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import {
  getAudioLanguages,
  getSubtitleCaptionLanguages,
} from '../../services/content/index'
import FileAttachmentsGraphQL from '../FileAttachmentsGraphQL/index'
import DetailPageV3InfoMetaItems from './DetailPageV3InfoMetaItems'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Map} props.featuredContent - The featured content data
 * @returns {JSX.Element} DetailPageV3InfoMeta
 */

const DetailPageV3InfoMeta = (props) => {
  const {
    detailData = Map(),
    featuredContent = Map(),
    staticText,
  } = props

  const contentType = featuredContent.get('contentType')
  const audioLanguages = getAudioLanguages({
    data: featuredContent,
    contentType,
  })
  const subtitleCaptionLanguages = getSubtitleCaptionLanguages({
    data: featuredContent,
    contentType,
  })

  return (
    <div className="detail-page-v3__info-meta">
      <div className="detail-page-v3__columns-layout">
        <div className="detail-page-v3__column detail-page-v3__column--content">
          <DetailPageV3InfoMetaItems detailData={detailData} isInline />
          {audioLanguages && audioLanguages.length > 0
            && <div className="detail-page-v3__meta-item detail-page-v3__meta-item--inline">
              <div className="detail-page-v3__meta-item-data">
                <span className="detail-page-v3__meta-item-label">
                  {staticText.get('audio')}
                </span>
                {': '}
                <span className="detail-page-v3__meta-item-text">
                  {audioLanguages}
                </span>
              </div>
            </div>
          }
          {subtitleCaptionLanguages && subtitleCaptionLanguages.length > 0
            && <div className="detail-page-v3__meta-item detail-page-v3__meta-item--inline">
              <div className="detail-page-v3__meta-item-data">
                <span className="detail-page-v3__meta-item-label">
                  {staticText.get('subtitles')}
                </span>
                {': '}
                <span className="detail-page-v3__meta-item-text">
                  {subtitleCaptionLanguages}
                </span>
              </div>
            </div>
          }
        </div>
        <div className="detail-page-v3__column detail-page-v3__column--content">
          <FileAttachmentsGraphQL
            data={detailData.get('assets') || List()}
            sectionTitle={staticText.get('downloadBonusMaterials')}
          />
        </div>
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3InfoMeta)
